import api from "../../config/http-common";

const getVisitorsEvents = () => {
  return api.securedAxios().get("/web/visitors/events");
};

const clearNotifications = () => {
  return api.securedAxios().delete("/web/visitors/events");
};

const VisitorsEventService = {
  getVisitorsEvents,
  clearNotifications,
};

export default VisitorsEventService;
